<template>
  <b-modal
    size="xl"
    centered
    hide-footer
    no-close-on-esc
    v-model="showModal"
    no-close-on-backdrop
    title="Erros importação projetos"
    @hide="fecharModalErrosImport"
  >
    <p style="text-align: justify">
      Abaixo está(ão) listado(s) o(s) erro(s) que ocorreu(eram) no momento da importação,
      onde a coluna <b>Linha CSV</b> é a linha em que o erro está localizado e a coluna
      <b>Mensagem de erro</b> é uma breve descrição do erro que ocorreu na linha.
    </p>

    <grid :colunas="colunas" :itensPorPagina="7" :dados="erros" :carregando="false" />
  </b-modal>
</template>

<script>
import grid from "@/components/grid";
import Swal from "sweetalert2";

export default {
  components: {
    grid,
  },
  props: {
    erros: { type: Array },
  },
  data() {
    return {
      showModal: false,
      confirmarFechar: false,
      colunas: [
        { key: "linha", label: "Linha CSV", sortable: true },
        { key: "mensagem", label: "Mensagem de erro", sortable: true },
      ],
    };
  },
  methods: {
    abrirModalErrosImport() {
      this.showModal = true;
    },
    fecharModalErrosImport(evt) {
      if (this.confirmarFechar) {
        this.confirmarFechar = false;
        return;
      }

      evt.preventDefault();

      Swal.fire({
        icon: "warning",
        title: "ATENÇÃO",
        text:
          "Caso confirme, será necessário importar o arquivo CSV novamente para ver os erros de importação. Deseja realmente sair?",
        showCancelButton: true,
        confirmButtonText: "Sim",
        cancelButtonText: "Não",
      }).then((result) => {
        if (result.isConfirmed) {
          this.showModal = false;
          this.confirmarFechar = true;
        }
      });
    },
  },
};
</script>

<style scoped>
::v-deep .card {
  border: none !important;
  box-shadow: none !important;
  background: transparent !important;
  padding: 0 !important;
  margin: 0 !important;
}

::v-deep .card-body {
  padding: 0 !important;
}
</style>
